import React from 'react'

const Footer =  () => {
    return (
        <div className="footer py-3 bg-light mt-5 text-center mt-3">
            footer
        </div>
    )
}

export default Footer
